package com.essntl.features.travelagent.domain.model

import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.file.domain.model.FileModel

data class TravelAgentModel(
    val id: String,
    val jobTitle: String?,
    val source: String?,
    val createdAt: String,
    val commissionType: CommissionType?,
    val commission: Double?,
    val qbCustomerId: String?,
    val contact: ContactModel?,
) {
    val prettyName
        get() = "${contact?.firstName ?: ""} ${contact?.lastName ?: ""}"

    val prettyNameOrganization
        get() = "${contact?.firstName ?: ""} ${contact?.lastName ?: ""} (${contact?.organization?.name})"

    val prettyCommission
        get() =
            if (commission != null && commissionType != null)
                " (${commission}% ${commissionType})" else ""

    val prettyDescription
        get() =
            "$prettyName, " + (contact?.organization?.name
                ?.capitalize()
                .orEmpty()) +
                prettyCommission

    fun getChangedFields(other: TravelAgentModel) =
        TravelAgentModel(
            id = id,
            createdAt = createdAt,
            jobTitle = if (jobTitle.orEmpty() != other.jobTitle.orEmpty()) other.jobTitle else null,
            source = if (source.orEmpty() != other.source.orEmpty()) other.source else null,
            commissionType = if (commissionType != other.commissionType) other.commissionType else null,
            commission = if (commission != other.commission) other.commission else 10.0,
            qbCustomerId = if (qbCustomerId != other.qbCustomerId) other.qbCustomerId else null,
            contact = if (contact?.id != other.contact?.id) other.contact else null,
        )

    enum class CommissionType {
        Net,
        Gross,
    }

    val isEmpty get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            TravelAgentModel(
                id = "",
                createdAt = "",
                jobTitle = null,
                source = null,
                commissionType = null,
                commission = 10.0,
                qbCustomerId = null,
                contact = null,
            )
    }
}